// Third-party
import React from 'react';
import { connect } from 'react-redux';

// Components
import SavedFunds from '../partials/SavedFunds';
import SavedBenchmarks from '../partials/SavedBenchmarks';
import SearchInput from '../../../components/inputs/SearchInput';
import { withErrorBoundary } from '../../../components/errors';
import Navigation from '../partials/FundScreenerNavigation';
import PageLayout from '../../layouts/PageLayout';

// Enums
import { SearchType } from '@/enums/AdvancedSearch';

// Utils
import { formatMessage } from '../../../../utils/i18n';
import { selectSavedFundsShelfStatusedFund } from '@/redux/modules/shelf-management/selectors';

// Types
import { ReduxState } from '../../../../redux/modules/types';
import { RouteComponentProps } from 'react-router';

type StateProps = {
  hasSavedItems: boolean;
};

type Props = RouteComponentProps &
  StateProps & {
    itemType: SearchType;
    query?: string;
  };

const SavedItemsPage = (props: Props) => {
  const [query, setQuery] = React.useState(props.query || '');

  const onSearchChange = (query: string) => {
    setQuery(query || '');
  };

  const renderSearchInput = () => {
    const { hasSavedItems } = props;

    if (!hasSavedItems) {
      return null;
    }

    const placeholder =
      props.itemType === SearchType.BENCHMARKS ? formatMessage('Search.Benchmarks.SavedPlaceholder') : formatMessage('Search.Funds.SavedPlaceholder');
    return <SearchInput className="search-input-v2" onChange={onSearchChange} placeholder={placeholder} value={query} />;
  };

  return (
    <PageLayout
      showHeader={false}
      layoutClassName="full-height"
      pageTitle="Search.PageTitle"
      pillsFilterElement={<Navigation />}
      searchInputElement={renderSearchInput()}
      mainClassName="search-page-v2"
    >
      {props.itemType === SearchType.FUNDS && <SavedFunds {...props} query={query} />}
      {props.itemType === SearchType.BENCHMARKS && <SavedBenchmarks {...props} query={query} />}
    </PageLayout>
  );
};

const getHasSavedItems = (state: ReduxState, itemType: SearchType) => {
  if (itemType === SearchType.FUNDS) {
    return selectSavedFundsShelfStatusedFund(state.funds.savedFunds).funds.length > 0;
  }
  return state.comparisonBenchmarks.savedBenchmarks.benchmarks.length > 0;
};

const mapStateToProps = (state: ReduxState, ownProps: Props): StateProps => ({
  hasSavedItems: getHasSavedItems(state, ownProps.itemType),
});

export default withErrorBoundary(connect(mapStateToProps)(SavedItemsPage));
